module.exports = __webpack_public_path__ + "static/img/img_map_03.8aa0ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dali/img_map_03.png
// module id = wbpr
// module chunks = 2